import React, { useState, useEffect } from "react";

function DatePickerPopup({ visible, onClose, onConfirm }) {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const days = Array.from({ length: getDaysInMonth(currentMonth, currentYear) }, (_, i) => i + 1);
  const monthName = new Date(currentYear, currentMonth).toLocaleString("en-US", {
    month: "short",
  });

  const handleDayClick = (day) => {
    const selected = new Date(currentYear, currentMonth, day);
    if (!startDate || (startDate && endDate)) {
      setStartDate(selected);
      setEndDate(null);
    } else if (selected >= startDate) {
      setEndDate(selected);
    } else {
      setStartDate(selected);
      setEndDate(null);
    }
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const handleConfirm = () => {
    if (startDate && endDate) {
      onConfirm({
        start: startDate.toISOString(),
        end: endDate.toISOString(),
      });
      onClose();
    }
  };

  const prevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear((y) => y - 1);
    } else {
      setCurrentMonth((m) => m - 1);
    }
  };

  const nextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear((y) => y + 1);
    } else {
      setCurrentMonth((m) => m + 1);
    }
  };

  if (!visible) return null;

  return (
    <div data-reactroot>
      <div className="am-popup-mask" onClick={onClose} />
      <div
        tabIndex={-1}
        className="am-popup-wrap EN new-date-picker yesbbdtf3"
        role="dialog"
      >
        <div role="document" className="am-popup am-popup-slide-up">
          <div className="am-popup-content">
            <button aria-label="Close" className="am-popup-close" onClick={onClose}>
              <span className="am-popup-close-x" />
            </button>

            <div className="am-popup-body">
              <div className="date-picker-content">
                <div className="btn-clear-date" onClick={handleClear}>
                  Clear
                </div>

                <div className="date-picker-title">
                  <div className={`picker-start-date ${startDate ? "active-item" : ""}`}>
                    {startDate
                      ? `${String(startDate.getMonth() + 1).padStart(2, "0")}/${startDate.getDate()}`
                      : "--/--"}
                  </div>
                  <div>-</div>
                  <div className={`picker-end-date ${endDate ? "active-item" : ""}`}>
                    {endDate
                      ? `${String(endDate.getMonth() + 1).padStart(2, "0")}/${endDate.getDate()}`
                      : "--/--"}
                  </div>
                </div>

                <div className="date-picker-warp">
                  <div className="date-picker-month">
                    <div className="btn-next-prev false" onClick={prevMonth}>
                      <svg className="am-icon am-icon-icon-arrow-left2_80e4e537 am-icon-md">
                        <use xlinkHref="#icon-arrow-left2_80e4e537" />
                      </svg>
                    </div>
                    <div className="picker-month">
                      {monthName.toUpperCase()} &nbsp;&nbsp;&nbsp; {currentYear}
                    </div>
                    <div className="btn-next-prev false" onClick={nextMonth}>
                      <svg className="am-icon am-icon-icon-arrow-right2_4ed0b71d am-icon-md">
                        <use xlinkHref="#icon-arrow-right2_4ed0b71d" />
                      </svg>
                    </div>
                  </div>

                  <div className="date-picker-week">
                    {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((d) => (
                      <div key={d} className="pickter-item week-item">
                        {d}
                      </div>
                    ))}
                  </div>

                  <div className="date-picker-days">
                    {days.map((d) => {
                      const thisDate = new Date(currentYear, currentMonth, d);
                      const isStart =
                        startDate &&
                        thisDate.toDateString() === startDate.toDateString();
                      const isEnd =
                        endDate &&
                        thisDate.toDateString() === endDate.toDateString();
                      const inRange =
                        startDate && endDate && thisDate > startDate && thisDate < endDate;

                      let cls = "pickter-item";
                      if (isStart) cls += " active-item start-item";
                      else if (isEnd) cls += " active-item end-item";
                      else if (inRange) cls += " through-item";

                      return (
                        <div
                          key={d}
                          className={cls}
                          onClick={() => handleDayClick(d)}
                        >
                          <span>{d}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="btn-confirm-date" onClick={handleConfirm}>
                  OK
                </div>
              </div>
            </div>
          </div>
          <div
            tabIndex={0}
            style={{ width: "0px", height: "0px", overflow: "hidden" }}
          >
            sentinel
          </div>
        </div>
      </div>
    </div>
  );
}

export default DatePickerPopup;
